<i18n locale="en">
{
  "label": "Brand Color"
}
</i18n>

<template>
  <OwnInputContainer :label="t('label')" :errors="inputStatus?.errors">
    <OwnColorPicker
      :model-value="themeBrandColor"
      @update:model-value="onUpdate"
    />
  </OwnInputContainer>
</template>

<script>
import debounce from 'lodash/debounce'
import set from 'lodash/set'
import { useI18n } from 'vue-i18n'
import { mapActions } from 'vuex'

import { Validators } from '@/forms'
import { useMergedTheme } from '@/lib/builder/public/preview/mixins/useMergedTheme'
import { OwnColorPicker } from '@/ui/OwnColorPicker'
import { OwnInputContainer } from '@/ui/OwnInputContainer'

export default {
  name: 'BrandColorEditor',
  components: { OwnColorPicker, OwnInputContainer },
  mixins: [useMergedTheme],
  setup() {
    const { t } = useI18n()

    return { t }
  },
  data() {
    return {
      inputStatus: undefined,
    }
  },
  computed: {
    themeBrandColor() {
      const { mergedTheme } = this

      return mergedTheme?.colors?.brand?.primary
    },
  },
  methods: {
    ...mapActions({
      updateResource: 'websiteBuilder/updateResource',
    }),
    async enqueueBrandColorUpdate(newValue) {
      const update = set({}, 'theme.overrides.colors.brand.primary', newValue)

      await this.updateResource(update)
    },
    execUpdate(newValue) {
      const validate = Validators.compose([
        Validators.required,
        Validators.color,
      ])

      const status = validate(newValue)

      this.inputStatus = status

      if (status.valid) {
        this.enqueueBrandColorUpdate(newValue)
      }
    },
    onUpdate: debounce(function (update) {
      this.execUpdate(update)
    }, 150),
  },
}
</script>
